import { requests } from 'api';
import { Initiator } from './types';

const apiBaseUrl = '/api/initiators';

export const InitiatorsApi = {
  getAll: (): Promise<Initiator[]> => requests.get(apiBaseUrl),
};
